/**************************************************
 * Nombre:       Tarjeta_Imagen_Reserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import 'react-medium-image-zoom/dist/styles.css'
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Imagen_Reserva = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 54.67%, #000 86.54%), url(${item.img})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                height: 320
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{
                        background: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 54.67%, #000 86.54%)",
                        color: '#fff',
                        p: 3
                    }}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 28, fontWeight: 800}}>{`Suite ${item.numero}`}</Typography>
                    </Grid>



                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                        <Typography sx={{
                            fontSize:18,
                            fontWeight:  600
                        }}>{`Valor Noche: ${formatoMoneda(item.tarifa)} USD`}</Typography>
                    </Grid>


                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Imagen_Reserva